import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IPaymentScreen_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IPaymentScreen_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  SaveThePaymentPlan: any[];
  SaveThePaymentPlan_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  Notify: boolean;
  Notify_dummy: boolean;
  ReadFromLocalStorage: string;
  ReadFromLocalStorage_dummy: string;
  GetPaymentPlan: any[];
  GetPaymentPlan_dummy: any[];
  BasketReportsDetailHeader: any[];
  BasketReportsDetailHeader_dummy: any[];
  GeneratePaymentByCartHeader: any[];
  GeneratePaymentByCartHeader_dummy: any[];
  PaymentLineCreate: number;
  PaymentLineCreate_dummy: number;
  GetPaymentPlanDetailByCartHeaderId: any[];
  GetPaymentPlanDetailByCartHeaderId_dummy: any[];
  UpdatePesinat: any[];
  UpdatePesinat_dummy: any[];
  UpdateTaksitBaslangicTarihi: any[];
  UpdateTaksitBaslangicTarihi_dummy: any[];
  isComp269565Visible: "visible" | "hidden";
  isComp933243Visible: "visible" | "hidden";
  isComp150346Visible: "visible" | "hidden";
}

export class PaymentScreen_ScreenBase extends React.PureComponent<
  IPaymentScreen_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  paymentscreen_324988_value_kuikaSelectBoxRef: React.RefObject<any>;
  paymentscreen_743440_value_kuikaDateRef: React.RefObject<any>;
  paymentscreen_956535_value_kuikaDateRef: React.RefObject<any>;
  paymentscreen_851043_value_kuikaTableRef: React.RefObject<any>;
  paymentscreen_946569_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "91458191-0263-4f5e-a845-1d009f13f01a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 616703, PropertyName: "label", Value: "Ödeme Planını Kaydet" },
        { Id: 377319, PropertyName: "value", Value: "Ödeme Planı" },
        { Id: 161615, PropertyName: "value", Value: "Sepet Bilgileri" },
        { Id: 271210, PropertyName: "value", Value: "Aktif" },
        { Id: 813709, PropertyName: "value", Value: "Müşteri Bilgileri" },
        { Id: 939391, PropertyName: "value", Value: "Satış Personeli" },
        { Id: 554057, PropertyName: "value", Value: "Sepetteki Ürün Adedi" },
        { Id: 862111, PropertyName: "value", Value: "Ödeme Planı" },
        {
          Id: 324988,
          PropertyName: "placeholder",
          Value: "Ödeme Planı Seçiniz...",
        },
        { Id: 413805, PropertyName: "value", Value: "Teslim Tarihi" },
        { Id: 743440, PropertyName: "placeholder", Value: "Teslim Tarihi" },
        { Id: 496886, PropertyName: "placeholder", Value: "Açıklama" },
        { Id: 588668, PropertyName: "value", Value: "Ödeme Planı" },
        { Id: 837868, PropertyName: "value", Value: "Peşinat" },
        { Id: 198835, PropertyName: "placeholder", Value: "15" },
        { Id: 903896, PropertyName: "value", Value: "Taksit Başlangıç Tarihi" },
        { Id: 956535, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 299279, PropertyName: "title", Value: "#" },
        { Id: 935354, PropertyName: "value", Value: "[datafield:linenum]" },
        { Id: 888213, PropertyName: "title", Value: "Vade Tarihi" },
        { Id: 216300, PropertyName: "value", Value: "[datafield:duedate]" },
        { Id: 435086, PropertyName: "title", Value: "Tutar" },
        { Id: 74349, PropertyName: "value", Value: "[datafield:amount]" },
        { Id: 454734, PropertyName: "value", Value: "Ürün Bilgileri" },
        { Id: 266192, PropertyName: "value", Value: "label" },
        { Id: 872531, PropertyName: "value", Value: "label" },
        { Id: 134350, PropertyName: "value", Value: "Ürün Bilgileri" },
        { Id: 848451, PropertyName: "title", Value: "#" },
        { Id: 261443, PropertyName: "value", Value: "1" },
        { Id: 332208, PropertyName: "title", Value: "Ürün kodu" },
        { Id: 518568, PropertyName: "value", Value: "label" },
        { Id: 820667, PropertyName: "title", Value: "Ürün Adı" },
        { Id: 666991, PropertyName: "value", Value: "label" },
        { Id: 431943, PropertyName: "title", Value: "Açıklama" },
        { Id: 340295, PropertyName: "value", Value: "label" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.paymentscreen_324988_value_kuikaSelectBoxRef = React.createRef();
    this.paymentscreen_743440_value_kuikaDateRef = React.createRef();
    this.paymentscreen_956535_value_kuikaDateRef = React.createRef();
    this.paymentscreen_851043_value_kuikaTableRef = React.createRef();
    this.paymentscreen_946569_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      SaveThePaymentPlan: [],
      GoBack: "",
      Notify: false,
      ReadFromLocalStorage: "",
      GetPaymentPlan: [],
      BasketReportsDetailHeader: [],
      GeneratePaymentByCartHeader: [],
      PaymentLineCreate: 0,
      GetPaymentPlanDetailByCartHeaderId: [],
      UpdatePesinat: [],
      UpdateTaksitBaslangicTarihi: [],
      isComp269565Visible: "hidden",
      isComp933243Visible: "hidden",
      isComp150346Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "paymentscreen",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.PaymentScreenPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.PaymentScreenPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "paymentscreen",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "paymentscreen",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.PaymentScreenPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.PaymentScreenPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      paymentscreen_324988_value:
        this.state.GetPaymentPlanDetailByCartHeaderId?.at?.(0)
          ?.paymentPlanCode ?? undefined,
      paymentscreen_743440_value:
        this.state.GetPaymentPlanDetailByCartHeaderId?.at?.(0)?.deliveryDate ??
        undefined,
      paymentscreen_496886_value:
        this.state.GetPaymentPlanDetailByCartHeaderId?.at?.(0)?.description ??
        undefined,
      paymentscreen_198835_value:
        this.state.GetPaymentPlanDetailByCartHeaderId?.at?.(0)
          ?.downPaymentAmount ?? undefined,
      paymentscreen_956535_value:
        this.state.GetPaymentPlanDetailByCartHeaderId?.at?.(0)
          ?.installmentStartDate ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  PaymentScreenPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromLocalStorage =
      await ReactSystemFunctions.readFromLocalStorage(
        ReactSystemFunctions.convertToTypeByName("CartHeaderId", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PaymentScreenPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  PaymentScreenPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      CartHeaderId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PaymentScreen/PaymentScreenPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetPaymentPlan = result?.data.getPaymentPlan;

    formVars.paymentscreen_324988_options = stateVars.GetPaymentPlan;
    stateVars.BasketReportsDetailHeader =
      result?.data.basketReportsDetailHeader;
    formVars.paymentscreen_770156_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].cartNo
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].cartNo
        : null
    );
    formVars.paymentscreen_938148_value = ReactSystemFunctions.value(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].createdAt
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].createdAt
        : null
    );
    formVars.paymentscreen_401593_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].curAccCode
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].curAccCode
        : null
    );
    formVars.paymentscreen_687061_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].customerName
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].customerName
        : null
    );
    formVars.paymentscreen_977732_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].salesPersonCode
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].salesPersonCode
        : null
    );
    formVars.paymentscreen_407767_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].salesPersonName
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].salesPersonName
        : null
    );
    formVars.paymentscreen_64581_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].totalQuantity
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].totalQuantity
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PaymentScreenPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PaymentScreenPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.paymentscreen_770156_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].cartNo
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].cartNo
        : null
    );

    formVars.paymentscreen_938148_value = ReactSystemFunctions.value(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].createdAt
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].createdAt
        : null
    );

    formVars.paymentscreen_401593_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].curAccCode
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].curAccCode
        : null
    );

    formVars.paymentscreen_687061_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].customerName
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].customerName
        : null
    );

    formVars.paymentscreen_977732_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].salesPersonCode
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].salesPersonCode
        : null
    );

    formVars.paymentscreen_407767_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].salesPersonName
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].salesPersonName
        : null
    );

    formVars.paymentscreen_64581_value = ReactSystemFunctions.toString(
      this,
      stateVars.BasketReportsDetailHeader !== undefined
        ? stateVars.BasketReportsDetailHeader?.length > 0
          ? stateVars.BasketReportsDetailHeader[0].totalQuantity
          : null
        : this.state.BasketReportsDetailHeader?.length > 0
        ? this.state.BasketReportsDetailHeader[0].totalQuantity
        : null
    );

    stateVars.dataSource_324988 =
      stateVars.GetPaymentPlan ?? this.state.GetPaymentPlan;
    stateVars.dataSource_324988 =
      stateVars.GetPaymentPlan ?? this.state.GetPaymentPlan;
    stateVars.isComp269565Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].lineNum
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].lineNum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  PaymentScreenComponent_616703_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toGuid(this, this.state.ReadFromLocalStorage),
        "Guid"
      ),
      InstallmentStartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "paymentscreen_956535_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      DownPaymentAmount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "paymentscreen_198835_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      PaymentPlanCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "paymentscreen_324988_value",
            "value",
            "GetPaymentPlan",
            "planCode",
            "planCode"
          )
        ),
        "string"
      ),
      DeliveryDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "paymentscreen_743440_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      Description_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "paymentscreen_496886_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PaymentScreen/PaymentScreenComponent_616703_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SaveThePaymentPlan = result?.data.saveThePaymentPlan;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PaymentScreenComponent_616703_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PaymentScreenComponent_616703_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.SaveThePaymentPlan !== undefined
            ? stateVars.SaveThePaymentPlan?.length > 0
              ? stateVars.SaveThePaymentPlan[0].success
              : null
            : this.state.SaveThePaymentPlan?.length > 0
            ? this.state.SaveThePaymentPlan[0].success
            : null
        ),
        true
      )
    ) {
      stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PaymentScreenComponent_616703_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.PaymentScreenComponent_616703_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  PaymentScreenComponent_616703_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.SaveThePaymentPlan !== undefined
          ? stateVars.SaveThePaymentPlan?.length > 0
            ? stateVars.SaveThePaymentPlan[0].message
            : null
          : this.state.SaveThePaymentPlan?.length > 0
          ? this.state.SaveThePaymentPlan[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PaymentScreenComponent_771006_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PaymentScreenComponent_324988_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
      PaymentPlanCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "paymentscreen_324988_value",
            "value",
            "GetPaymentPlan",
            "planCode",
            "planCode"
          )
        ),
        "string"
      ),
      CartId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
      CartId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PaymentScreen/PaymentScreenComponent_324988_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GeneratePaymentByCartHeader =
      result?.data.generatePaymentByCartHeader;
    stateVars.PaymentLineCreate = result?.data.paymentLineCreate;
    stateVars.GetPaymentPlanDetailByCartHeaderId =
      result?.data.getPaymentPlanDetailByCartHeaderId;

    formVars.paymentscreen_324988_value =
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
        : null;
    formVars.paymentscreen_743440_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
        : null
    );
    formVars.paymentscreen_496886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].description
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].description
        : null
    );
    formVars.paymentscreen_198835_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
        : null
    );
    formVars.paymentscreen_956535_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
        : null
    );
    stateVars.isComp269565Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].lineNum
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].lineNum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PaymentScreenComponent_324988_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PaymentScreenComponent_324988_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.paymentscreen_324988_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
        : null
    );

    formVars.paymentscreen_743440_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
        : null
    );

    formVars.paymentscreen_496886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].description
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].description
        : null
    );

    formVars.paymentscreen_198835_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
        : null
    );

    formVars.paymentscreen_956535_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
        : null
    );

    stateVars.dataSource_851043 =
      stateVars.GetPaymentPlanDetailByCartHeaderId ??
      this.state.GetPaymentPlanDetailByCartHeaderId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PaymentScreenComponent_198835_onBlur = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
      DownPaymentAmount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "paymentscreen_198835_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      CartId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PaymentScreen/PaymentScreenComponent_198835_onBlur",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdatePesinat = result?.data.updatePesinat;
    stateVars.GetPaymentPlanDetailByCartHeaderId =
      result?.data.getPaymentPlanDetailByCartHeaderId;

    formVars.paymentscreen_324988_value =
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
        : null;
    formVars.paymentscreen_743440_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
        : null
    );
    formVars.paymentscreen_496886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].description
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].description
        : null
    );
    formVars.paymentscreen_198835_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
        : null
    );
    formVars.paymentscreen_956535_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
        : null
    );
    stateVars.isComp269565Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].lineNum
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].lineNum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PaymentScreenComponent_198835_onBlur1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PaymentScreenComponent_198835_onBlur1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.paymentscreen_324988_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
        : null
    );

    formVars.paymentscreen_743440_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
        : null
    );

    formVars.paymentscreen_496886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].description
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].description
        : null
    );

    formVars.paymentscreen_198835_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
        : null
    );

    formVars.paymentscreen_956535_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
        : null
    );

    stateVars.dataSource_851043 =
      stateVars.GetPaymentPlanDetailByCartHeaderId ??
      this.state.GetPaymentPlanDetailByCartHeaderId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PaymentScreenComponent_956535_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CartId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
      InstallmentStartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "paymentscreen_956535_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      CartId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CartHeaderId ??
          this.props.screenInputs.cartheaderid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PaymentScreen/PaymentScreenComponent_956535_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UpdateTaksitBaslangicTarihi =
      result?.data.updateTaksitBaslangicTarihi;
    stateVars.GetPaymentPlanDetailByCartHeaderId =
      result?.data.getPaymentPlanDetailByCartHeaderId;

    formVars.paymentscreen_324988_value =
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
        : null;
    formVars.paymentscreen_743440_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
        : null
    );
    formVars.paymentscreen_496886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].description
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].description
        : null
    );
    formVars.paymentscreen_198835_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
        : null
    );
    formVars.paymentscreen_956535_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
        : null
    );
    stateVars.isComp269565Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
            ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
              ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].lineNum
              : null
            : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
            ? this.state.GetPaymentPlanDetailByCartHeaderId[0].lineNum
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PaymentScreenComponent_956535_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PaymentScreenComponent_956535_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.paymentscreen_324988_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].paymentPlanCode
        : null
    );

    formVars.paymentscreen_743440_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].deliveryDate
        : null
    );

    formVars.paymentscreen_496886_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].description
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].description
        : null
    );

    formVars.paymentscreen_198835_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].downPaymentAmount
        : null
    );

    formVars.paymentscreen_956535_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPaymentPlanDetailByCartHeaderId !== undefined
        ? stateVars.GetPaymentPlanDetailByCartHeaderId?.length > 0
          ? stateVars.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
          : null
        : this.state.GetPaymentPlanDetailByCartHeaderId?.length > 0
        ? this.state.GetPaymentPlanDetailByCartHeaderId[0].installmentStartDate
        : null
    );

    stateVars.dataSource_851043 =
      stateVars.GetPaymentPlanDetailByCartHeaderId ??
      this.state.GetPaymentPlanDetailByCartHeaderId;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.PaymentScreenPageInit();
    }
  }
}
